import { render } from "./UploadFiles.vue?vue&type=template&id=0e9a52b2&scoped=true"
import script from "./UploadFiles.vue?vue&type=script&lang=js"
export * from "./UploadFiles.vue?vue&type=script&lang=js"

import "./UploadFiles.vue?vue&type=style&index=0&id=0e9a52b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e9a52b2"]])

export default __exports__